/*
 * @Description: 房源维护列表
 * @Author: 段生华
 * @Date: 2019-05-07 17:20:24
 * @LastEditTime: 2019-07-04 11:51:33
 * @LastEditors: Please set LastEditors
 */

import React from 'react';
import { Button, message, Divider, Popconfirm, Upload,Modal } from 'antd';
import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import {postFrom, config, transterQuery, post} from '../../axios';
import {dicHouseStatus, downloadTagsMap, syncStatusIsMap} from '../../axios/dictionaries';
import {formatTime, handleExportParams, isPlatform} from '../../utils';
import JrApiLog from "../Other/JrApiLog";
import HouseTypeDetail from "./detail";
import DeviceDetail from "./deviceDetail";
import {
    API_roomType_batchGeneration,
} from "../../axios/config";

export default class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false, //页面加载中
            params: { //搜索参数
                keyword: '',
                syncStatus:'',
                status: '',
                pageSize: 10,
            },
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            showAddModal: false, //新增组件弹窗
        }

        let loginData = Cookies.get('loginData');
        if (loginData) { //校验登录是否失效
            loginData = JSON.parse(loginData);
            if (loginData.merchantId) {  //为商户人员添加商户id
                this.merchantId = loginData.merchantId || 0;
            }
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => { //表单搜索/分页
        let { params, current } = this.state;
        let data = {};

        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });

        postFrom({ url: config.API_roomType_findRoomDevicePageList, data }).then(res => {
            this.setState({ current: res.current, tableTotal: res.total, tableData: res.records, tableLoading: false });
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        });
    }

    handleJrApiLogInfo(tableName,id) {
        //console.log(this);
        this.jrApiLogRef.open(tableName,id);
    }

    // handleEdit = (id) => { //编辑
    //     this.setState({ showAddModal: true });
    //     this.maintainAddRef.loadPack({ id });
    //     this.maintainAddRef.loadBuildingList();
    // }

    handleRemove = (id) => { //删除
        this.setState({ tableLoading: false });
        let data = { houseId: id };
        postFrom({ url: config.API_house_deleteHouse, data }).then(res => {
            this.setState({ tableLoading: false });
            this.handleSearch();
        }).catch(err => {
            message.error(err.message || '删除失败');
            this.setState({ tableLoading: false });
        });
    }
    handleEdit = (id) => {
        postFrom({ url: config.API_roomType_downloadImages+"?checkRoomDeviceId="+id }).then(res => {
            const ele = document.createElement('a'); //新建一个a标签
            ele.setAttribute('href', res);
            ele.setAttribute('target', "blank");
            document.body.appendChild(ele);
            ele.click();
            ele.remove();
        }).catch(err => {
            message.error(err.message || '下载二维码失败');
            this.setState({ tableLoading: false });
        });
    }

    handleInfo = (id) => {
        this.DeviceDetailRef.open(id).then(res => {
            this.handleSearch()
        })
    }

    postAsyncBatchCheck(id) {
        return post({ url: API_roomType_batchGeneration  +'?id=' + id }).then(() => {
            message.success('批量生成中，请10到20分钟后查看')
        }).catch(e => {
            message.error(e.message)
        })
    }

    handleAsyncBatchCheck() {
        this.postAsyncBatchCheck().then(() =>{
            this.handleSearch()
        })
    }


    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
        } = this.state;
        return (
            <PageWrap
                loading={loading}
            >
                <div className="search-wrapper">
                    <div className="search-btn-list">
                        <AuthButton authkey="z-6-2"  type="primary" icon="export">
                            <Popconfirm title="确认一键生成吗？可能需要10到20分钟" onConfirm={this.handleAsyncBatchCheck.bind(this)}>
                                <a>一键生成二维码</a>
                            </Popconfirm>
                        </AuthButton>
                        <AuthButton authkey="z-6-3" type="primary" icon="export" href={`${config.API_report_roomTypeDownload}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出二维码压缩包
                        </AuthButton>
                        <AuthButton authkey="z-6-4" type="primary" icon="export" href={`${config.API_report_roomTypeDownloadExcel}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                            导出Excel
                        </AuthButton>
                    </div>
                    <SuperForm
                        data={searchData()}
                        sumbit={this.handleSearch}
                        addParams={'current'}
                    />
                </div>
                <TableDOM
                    columns={columns({ current, handleEdit: this.handleEdit, handleInfo: this.handleInfo,handleJrApiLogInfo:this.handleJrApiLogInfo.bind(this) })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                    scroll={{x: 1500}}
                />
                <JrApiLog ref={ref=>{
                    this.jrApiLogRef=ref;
                }}/>
                <HouseTypeDetail wrappedComponentRef={ ref=> this.HouseTypeDetailRef = ref } />
                <DeviceDetail wrappedComponentRef={ ref=> this.DeviceDetailRef = ref } />
            </PageWrap>
        )
    }


}

const searchData = () => {
    let data =  [
    {
        tagName: 'Select',
        formConfig: { name: 'downloadTags' },
        attribute: { placeholder: '请选择是否下载', style: { width: '140px' } },
        optionData: [{ title: '全部', value: '' }].concat(downloadTagsMap), //.concat(dicHouseStatus)
        notResult: '',
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'roomTypeName' },
        attribute: { placeholder: '输入户型名称', style: { width: '160px' } },
        title: `在户型名称模糊查询`
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'projectName' },
        attribute: { placeholder: '输入项目名称', style: { width: '160px' } },
        title: `在项目名称模糊查询`
    }, {
        tagName: 'InputTip',
        formConfig: { name: 'buildingName' },
        attribute: { placeholder: '输入小区/楼栋', style: { width: '160px' } },
        title: `在小区/楼栋名称模糊查询`
    }, {
        tagName: 'InputTip',
        formConfig: { name: 'houseName' },
        attribute: { placeholder: '输入房号', style: { width: '160px' } },
        title: `在房号模糊查询`
    },
    {
        tagName: 'InputTip',
        formConfig: { name: 'ccbProjectName' },
        attribute: { placeholder: '输入门店名称', style: { width: '160px' } },
        title: `在门店名称模糊查询`
    }
]

   /* data = data.filter(e => {
        if(isPlatform()){
            return true;
        }
        if (e.formConfig.name === 'syncStatus') {
            return false;
        }
        return true;
    });*/

    return data;
};

const columns = ({ handleEdit, handleInfo,handleJrApiLogInfo }) => [
    {
        title: '项目名称',
        dataIndex: 'projectName',
        fixed: 'left'
    },
    {
        title: '小区/楼栋',
        dataIndex: 'buildingName'
    },
    {
        title: '门店名称',
        dataIndex: 'ccbProjectName'
    },
    {
        title: '户型',
        dataIndex: 'roomTypeName'
    },
    {
        title: '房源编号',
        dataIndex: 'houseNo'
    },
    {
        title: '房号',
        dataIndex: 'houseName'
        , width:80 ,
    },
    {
        title: '户型品类',
        dataIndex: 'categoryName'
        , width:80 ,
    },
    {
        title: '设备品类',
        dataIndex: 'deviceCategory'
        , width:80 ,
    },
    {
        title: '设备型号',
        dataIndex: 'deviceModel'
    },
    {
        title: '二维码是否生成',
        dataIndex: 'qrCodeUrl',
        render(text, record, index) {
            return <span>
                <div>{record.qrCodeUrl ? '已生成' : "未生成"}</div>
            </span>
        }
    },
    {
        title: '二维码生成时间',
        dataIndex: 'qrCodeTime',
        render(text) {
            if (!text) return '-'
            return formatTime(text)
        }
    },
    {
        title: '是否下载',
        dataIndex: 'downloadTags',
        render(text, record, index) {
            return <span>
                <div>{record.downloadTags===1 ? '已下载' : "未下载"}</div>
            </span>
        }
    },
    {
        title: '下载时间',
        dataIndex: 'downloadTime',
            render(text) {
                if (!text) return '-'
        return formatTime(text)
        }
    },
    {
        title: '操作',
        dataIndex: 'action',
        width: 200,
        fixed: 'right',
        render(text, record, index) {
            const rentLink = {
                pathname: '/admin/operate/repairReport',
                state: { checkDeviceId: record.id }
            }
            return <span>
                 <AuthButton authkey="z-6-5">
                    <a  onClick={() => { handleEdit(record.id) }}>下载二维码</a>
                </AuthButton>
                <AuthButton authkey="z-6-6">
                    <Divider type="vertical" />
                     <Link to={rentLink}>报修记录</Link>
                </AuthButton>
            </span>
        }
    }
];


// WEBPACK FOOTER //
// ./src/page/OperateDevice/HouseDevice.js